interface MilleEtUnTheme {
  headerImage: string;
  color: string;
}

const MilleEtUnTheme: { [key: string]: MilleEtUnTheme } = {
  bistrot: {
    headerImage: '/storage/templates/bandeau_bistrot.png.webp',
    color: '#BFAC9D',
  },
  bistrotmetz: {
    headerImage: '/storage/templates/bandeau_bistrot_metz.png.webp',
    color: '#BFAC9D',
  },
  bistrotthones: {
    headerImage: '/storage/templates/bandeau_bistrot_thones.png.webp',
    color: '#BFAC9D',
  },
  commealamaison: {
    headerImage: '/storage/templates/bandeau_commealamaison.png.webp',
    color: '#A87051',
  },
  atelier: {
    headerImage: '/storage/templates/bandeau_atelier.png.webp',
    color: '#474746',
  },
  boucher: {
    headerImage: '/storage/templates/bandeau_boucher.png.webp',
    color: '#A87051',
  },
  plancha: {
    headerImage: '/storage/templates/bandeau_plancha.png.webp',
    color: '#0D2328',
  },
  baraplancha: {
    headerImage: '/storage/templates/bandeau_baraplancha.png.webp',
    color: '#0D2328',
  },
  etaldumarche: {
    headerImage: '/storage/templates/bandeau_etaldumarche.png.webp',
    color: '#197B45',
  },
  menueco: {
    headerImage: '/storage/templates/bandeau_menueco.png.webp',
    color: '#98B1B6',
  },
  marayeur: {
    headerImage: '/storage/templates/marayeur.png.webp',
    color: '#111b56',
  },
};

export const getMilleEtUnTheme = (theme?: string): MilleEtUnTheme => {
  if (theme && MilleEtUnTheme[theme]) {
    return MilleEtUnTheme[theme];
  }
  return MilleEtUnTheme.maree;
};

export const theme = {
  bistrot: {
    headerImage: '/storage/templates/bistrot.png.webp',
    color: '#BFAC9D',
  },
  atelier: {
    headerImage: '/storage/templates/atelier.png.webp',
    color: '#474746',
  },
  boucher: {
    headerImage: '/storage/templates/boucher.png.webp',
    color: '#A87051',
  },
  plancha: {
    headerImage: '/storage/templates/plancha.png.webp',
    color: '#0D2328',
  },
  etaldumarche: {
    headerImage: '/storage/templates/etaldumarche.png.webp',
    color: '#197B45',
  },
  menueco: {
    headerImage: '/storage/templates/menueco.png.webp',
    color: '#98B1B6',
  },
  marayeur: {
    headerImage: '/storage/templates/marayeur.png.webp',
    color: '#111b56',
  },
};
